import React from 'react';
import {dropdownFillBlack} from 'assets/images/images';
import {Accordion} from '../../../components';
import {DetailRow} from './DetailRow';

function LocationAndGeographic({data = {}}) {
  const {geographic_summary = {}, address_verification = {}} = data;

  return (
    <div className="bg-white rounded-xl py-4 flex flex-col gap-4">
      <div className="px-6 flex flex-col gap-1">
        <h4 className="text-deepBlue font-medium">
          Location & Geographic Activity
        </h4>
      </div>

      <div className="px-3 flex flex-col gap-4">
        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Geographic Summary"
        >
          <div className="mt-1">
            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-1 pb-4">
              PRIMARY LOCATION
            </h5>
            <DetailRow
              label="Most frequent location or country of activity"
              value={
                geographic_summary.most_frequent_location_or_country_of_activity
              }
            />

            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-4 pb-4 border-t border-[#F6F7F9]">
              DISTINCT GEOS (90D)
            </h5>
            <DetailRow
              label="Number of unique countries or regions observed"
              value={
                geographic_summary.number_of_unique_countries_or_regions_observed
              }
            />

            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-4 pb-4 border-t border-[#F6F7F9]">
              GEO CONSISTENCY
            </h5>
            <DetailRow
              label="Match rate between IP country, card BIN country, and registered address."
              value={
                geographic_summary.match_rate_between_ip_country_card_bin_country_and_registered_address
              }
            />
          </div>
        </Accordion>

        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Address Verification"
        >
          <div className="mt-1">
            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-1 pb-4">
              VERIFIED ADDRESS
            </h5>
            <DetailRow
              label="Indicates whether the physical or billing address has been validated"
              value={
                address_verification.indicates_whether_the_physical_or_billing_address_has_been_validated
              }
            />

            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-4 pb-4 border-t border-[#F6F7F9]">
              RECENT GEO CHANGES
            </h5>
            <DetailRow
              label="Most recent country or region transitions"
              value={
                address_verification.most_recent_country_or_region_transitions
              }
            />

            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-4 pb-4 border-t border-[#F6F7F9]">
              DISTANCE DRIFT (AVG KM):
            </h5>
            <DetailRow
              label="Average distance between consecutive transaction geolocations."
              value={
                address_verification.average_distance_between_consecutive_transaction_geolocations
              }
            />
          </div>
        </Accordion>

        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Geo Flags"
        >
          <div className="mt-1">
            <p className="text-small text-[#858DAA] capitalize py-2 border-[0.5px] border-transparent border-b-[#F6F7F9]">
              Frequent cross-border activity{' '}
            </p>
            <p className="text-small text-[#858DAA] capitalize py-2 border-[0.5px] border-transparent border-b-[#F6F7F9]">
              BIN vs IP country mismatch
            </p>
          </div>
        </Accordion>
      </div>
    </div>
  );
}

export default LocationAndGeographic;
